import type { ModuleDefinition } from '@em-cms/core';

export const moduleConfig = {
  id: 'storage',
  name: 'فضای ابری',
  description: 'مدیریت فضای ابری و ذخیره‌سازی',
  version: '0.1.0',
  is_core: false,
  requires: [],
  tables: ['cms_storage_providers', 'cms_storage_quotas', 'cms_storage_usage'],
};

export const storageModule: ModuleDefinition = {
  id: 'storage',
  name: 'فضای ابری',
  description: 'مدیریت فضای ابری و ذخیره‌سازی',
  version: '0.1.0',
  icon: 'HardDrive',
  category: 'utility',
  dependencies: [],
  tables: ['cms_storage_providers', 'cms_storage_quotas', 'cms_storage_usage'],
  adminRoutes: [
    {
      path: '/storage',
      component: () => import('./admin/StorageProvidersPage').then(m => ({ default: m.StorageProvidersPage })),
      permission: 'storage.read',
      label: 'فضای ابری',
      icon: 'HardDrive',
    },
    {
      path: '/storage/providers',
      component: () => import('./admin/StorageProvidersPage').then(m => ({ default: m.StorageProvidersPage })),
      permission: 'storage.manage_providers',
      label: 'ارائه‌دهندگان',
      icon: 'Server',
    },
    {
      path: '/storage/quotas',
      component: () => import('./admin/StorageQuotasPage').then(m => ({ default: m.StorageQuotasPage })),
      permission: 'storage.manage_quotas',
      label: 'سهمیه‌ها',
      icon: 'Database',
    },
    {
      path: '/storage/dashboard',
      component: () => import('./admin/StorageUsageDashboard').then(m => ({ default: m.StorageUsageDashboard })),
      permission: 'storage.read_dashboard',
      label: 'داشبورد استفاده',
      icon: 'BarChart3',
    },
    {
      path: '/storage/migration',
      component: () => import('./admin/StorageMigrationPage').then(m => ({ default: m.StorageMigrationPage })),
      permission: 'storage.manage_migration',
      label: 'انتقال',
      icon: 'ArrowLeftRight',
    },
    {
      path: '/storage/alerts',
      component: () => import('./admin/StorageAlertsPage').then(m => ({ default: m.StorageAlertsPage })),
      permission: 'storage.manage_alerts',
      label: 'هشدارها',
      icon: 'Bell',
    },
    {
      path: '/storage/optimization',
      component: () => import('./admin/StorageOptimizationPage').then(m => ({ default: m.StorageOptimizationPage })),
      permission: 'storage.manage_optimization',
      label: 'بهینه‌سازی',
      icon: 'Zap',
    },
  ],
};
